// extracted by mini-css-extract-plugin
export default {"error":"kO7WAklkCw1F9AFVjxOEbQ==","liveRegion":"CkrVXtP94yROXiX+XvOoVw=="};